import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalendarEdit"><Path d="M8.5 2H7V4H3V21H12V19.5H4.5V10H19.5V11H21V4H17V2H15.5V4H8.5V2Z" fill="currentColor"/><Path d="M20.25 12.6893L14 18.9393V22H17.0607L23.3107 15.75L20.25 12.6893Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarEdit;
